import { useStatQuery } from '@famly/stat_use-stat-query';
import { KinderConnectCaptureRequiredForLeaves } from './kinder-connect-capture-required-for-leaves.query';
/**
 * Fetches whether KinderConnect TWC media capture (photo, signature, GPS) is required for a leave
 * or holiday-reply submission covering the given children -- true if it's required for *any* of
 * them (computed server-side). Feed the result into
 * `useIsKinderConnectCaptureEnabledForLeaves` from `@famly/stat_kinder-connect-capture_business-logic`
 * rather than reading `data`/`error` directly.
 *
 * @param options - Apollo query options; must include `variables: {childIds}`.
 * @returns The query result, with `data.childrenLeaves.kinderConnectCaptureRequired` holding the
 * boolean once loaded.
 */
export function useKinderConnectCaptureRequiredForLeavesQuery(options) {
    return useStatQuery(KinderConnectCaptureRequiredForLeaves, options);
}
